/* @flow strict */

import React from 'react';
import _ from 'lodash';
import ReactSummernote from 'react-summernote';
import { SummenrNoteToolbar, SummenrNoteToolbarHeight10Lines } from 'client/src/constants';
import { getWordsCount } from 'client/src/utils/string';

type PropsType = {
  value: string,
  limit?: number,
  noLimit?: boolean,
  customClass?: string,
  onChange: (any) => void,
  handleOnInit?: (any) => void,
  handleSetValidationError?: (any) => void
};


const TextEditor = ({ value, limit, noLimit = false, customClass, onChange, handleOnInit, handleSetValidationError }: PropsType) => {
  const vMsgRef = React.useRef(null);
  const ReactSummernoteRef = React.useRef(null);
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);

  setTimeout(() => {
    const resizebleEl = document.querySelector('.js-anchor-TextEditor .note-editable.panel-body');

    if (resizebleEl) {
      resizebleEl.style.resize = 'vertical';
    }
  }, 1000);

  const _limit = limit ? limit : 5000;

  const resetPastedTextStyles = (e: any) => {
    const clipboardData = ((e.originalEvent || e).clipboardData || window.clipboardData);
    const bufferText = clipboardData.getData('Text');
    const bufferHtml = clipboardData.getData('text/html');

    if (bufferHtml.indexOf('SparxoCopy') > -1) {
      // allow html markup
    } else {
      const p = bufferText.split('\n');

      let text = '';

      for (let i = 0; i < p.length; i++) {
        const s = $('<p></p>').text(p[i]).html();

        text += `<p>${s}</p>`;
      }

      if (text !== '') {
        document.execCommand('insertHTML', false, text);
      }
      e.preventDefault();
    }
  };

  React.useEffect(() => {
    if (!!handleSetValidationError) handleSetValidationError(isShowLimitWarning);
  }, [isShowLimitWarning]);

  return (
    <div
      className={`js-anchor-TextEditor ${customClass ? customClass : ''} ${isShowLimitWarning ? 'validationElement' : ''}`}
      style={{
        position: 'relative'
      }}
    >
      <ReactSummernote
        ref={ReactSummernoteRef}
        children={<div dangerouslySetInnerHTML={{ __html: value }} />}
        options={{
          lang: 'en-US',
          height: SummenrNoteToolbarHeight10Lines,
          dialogsInBody: true,
          toolbar: SummenrNoteToolbar
        }}
        onPaste={(e: any): void => resetPastedTextStyles(e)}
        onChange={(data: string) => {
          if (!noLimit) {
            const editorField = _.get(ReactSummernoteRef, 'current.editor[0].parentNode.parentNode', null);

            if (editorField) {
              editorField.querySelector('.note-editable').classList.remove('validationElement');
            }

            const _isShowLimitWarning = getWordsCount(data) - 11 > _limit;

            toggleShowLimitWarning(_isShowLimitWarning);
            vMsgRef.current.style.display = _isShowLimitWarning ? 'block' : 'none';
          }

          onChange(data);
        }}
        onFocus={() => {
          toggleShowLimitLabel(true);
        }}
        onBlur={() => {
          toggleShowLimitLabel(false);
        }}
        onInit={(): any => !!handleOnInit ? handleOnInit() : null}
      />

      {!noLimit && isShowLimitLabel &&
        <span className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-summernote'>
          {getWordsCount(value)}/{_limit}
        </span>
      }

      <div
        className='ReactSummernote-vMsg vMsg'
        ref={vMsgRef}
      >
        {isShowLimitWarning ?
          `Please enter no more than ${_limit} characters.` :
          'This field is required.'
        }
      </div>
    </div>: null
  );
};

export  default TextEditor;
